namespace SP.Data {
    export class PickList {
        //private static pickListInfo: { [pickListId: number]: PickListInfo } = {};

        static async getPickListInfo(pickListId: number, useCache = true): Promise<PickListInfo> {
            //if (useCache && this.pickListInfo[pickListId] != null) return this.pickListInfo[pickListId];
            var response = await SP.get<any>("/api/v1/info/pickListInfo/" + pickListId);
            if (response.status == 200) return response.data as PickListInfo; // this.pickListInfo[pickListId] = response.data;
            else await SP.alertX(response.status + ": " + response.msg);
            //return this.pickListInfo[pickListId];
            return null;
        }

        static async getPickListInfoFromTote(toteId: number): Promise<PickListInfo> {
            var response = await SP.get<any>("/api/v1/picklist/get/?toteId=" + toteId);
            if (response.status == 200) return response.data as PickListInfo; // this.pickListInfo[pickListId] = response.data;
            return null;
        }

        static async getPickListInfos(): Promise<PickListInfo[]> {
            var response = await SP.get<any>("/api/v1/info/pickListInfos?active=1");
            if (response.status != 200) await SP.alertX(response.status + ": " + response.msg);
            return response.data;
        }

        static async getFinishedPickListInfos(): Promise<PickListInfo[]> {
            var response = await SP.get<any>("/api/v1/info/pickListInfos?ready=0");
            if (response.status != 200) await SP.alertX(response.status + ": " + response.msg);
            return response.data;
        }

        static async getPickListLinesData(pickListId: number): Promise<PickListLineData[]> {
            var response = await SP.get<any>("/api/v1/picklist/getLines/" + pickListId);
            if (response.status != 200) await SP.alertX(response.status + ": " + response.msg);
            return response.data;
        }

        static async getPickListProductionData(pickListId: number): Promise<ProductionOrderInfo[]> {
            var response = await SP.get<any>("/api/v1/picklist/getProductionItemInfos/" + pickListId);
            if (response.status != 200) await SP.alertX(response.status + ": " + response.msg);
            return response.data;
        }
    }
}